exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ndv_modal_tabs a {\r\n  width: 500px;\n}\r\n", ""]);

// exports
